export const LAWYER_ARTICLES_PER_PAGE = 3;
export const COMPANY_PUBLICATIONS_PER_PAGE = 2;

export const ARTICLES_LOAD_ERROR = 'Ошибка при загрузке статей юриста:';
export const PUBLICATIONS_LOAD_ERROR = 'Ошибка при загрузке публикаций организации:';

export const PUBLICATIONS_EMPTY_TEXT =
  'Автор профиля пока не указал информацию о публикациях';
